export interface SlashCommand {
  name: string;
  description: string;
}

export const SLASH_COMMANDS: SlashCommand[] = [
  { name: '/quit', description: 'Exit the session' },
  { name: '/history', description: 'Show conversation history' },
  { name: '/clear', description: 'Clear the screen' },
  { name: '/status', description: 'Show session info' },
  { name: '/compact', description: 'Compact conversation context' },
  { name: '/new', description: 'Start a fresh session' },
  { name: '/sessions', description: 'List recent sessions' },
  { name: '/name', description: 'Name the current session' },
];

/** Tab-complete a slash command prefix. Returns matching command names. */
export function completeSlashCommand(prefix: string): string[] {
  return SLASH_COMMANDS
    .filter((cmd) => cmd.name.startsWith(prefix))
    .map((cmd) => cmd.name);
}

/** Check if input is a known slash command (ignoring arguments). */
export function isSlashCommand(input: string): boolean {
  const [command] = parseSlashCommand(input);
  return SLASH_COMMANDS.some((cmd) => cmd.name === command);
}

/** Parse slash command into [command, args]. */
export function parseSlashCommand(input: string): [string, string] {
  const trimmed = input.trimStart();
  const spaceIndex = trimmed.indexOf(' ');
  if (spaceIndex === -1) {
    return [trimmed, ''];
  }
  return [trimmed.slice(0, spaceIndex), trimmed.slice(spaceIndex + 1).trimStart()];
}
